import 'bluebird-global'
import {install} from '@material-ui/styles'

install()
